import moment from 'moment'

export default function (time) {
  if (!time) {
    return '';
  }
  return moment(time, 'kk:mm').format('k:mm')
}
